import _ from 'lodash'
import SubscriptionRecord from '../billing/SubscriptionRecord'

class AnalyticsUserPropertiesService {
  constructor($analytics, SubscriptionService) {
    this.$analytics = $analytics
    this.SubscriptionService = SubscriptionService
  }

  sendUserProperties(user) {
    if (!user) {
      this.$analytics.setUsername(null)
      this.$analytics.setUserProperties({})
      return
    }

    this.$analytics.setUsername(user.userId)
    this.$analytics.setUserProperties({
      userId: user.userId,
      $first_name: user.firstName,
      $last_name: user.lastName,
      $name: user.email,
      $email: user.email
    })
  }

  gatherAndSendUserSubscription() {
    this.SubscriptionService.subscription(this._sendUserSubscription.bind(this))
  }

  _sendUserSubscription(subscriptionPromise) {
    const subscription = new SubscriptionRecord(subscriptionPromise.subscription)
    this.$analytics.setUserProperties({
      'Subscription Status': subscription.state,
      'Subscription Start': subscription.activatedAt,
      'Paying Subscriber': true,
      'Subscription Cancelled Date': subscription.canceledAt,
      'Subscription Expiration': subscription.expiresAt,
      'States': subscription.prettyAddOns,
      'Subscription': subscription.plan
    })
  }
}

AnalyticsUserPropertiesService.$inject = [
  '$analytics',
  'SubscriptionService'
]

export default AnalyticsUserPropertiesService
